import { FC } from 'react';
import setting from 'images/settings.svg';

const SettingIcon: FC = (props): JSX.Element => {
  return <img src={setting} alt="setting-icon" />;
};
export default SettingIcon;
